import { Stack, SxProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import DeviceStateEnum, { getDeviceStateLabel } from '~enums/deviceStateEnum';
import { BaseReference } from '~interfaces';
import { Dimens } from '~themes';

import Dropdown from './dropdown';

interface DeviceStateDropdownProps {
	onValueChanged: (newValue?: DeviceStateEnum) => void;
	disableClearable?: boolean;
	selectedValue?: DeviceStateEnum;
	label?: string;
	sx?: SxProps;
}

const DeviceStateDropdown = ({ label, sx, ...props }: DeviceStateDropdownProps) => {
	const { t } = useTranslation();

	// Data
	const options = [DeviceStateEnum.Available, DeviceStateEnum.None, DeviceStateEnum.Unknown].map(
		(option) =>
			({
				id: option as string,
				name: option ? getDeviceStateLabel(option, t) : t('general.none', { ns: 'entities' }),
			}) as BaseReference
	);

	// Component
	return (
		<Stack sx={{ gap: Dimens.spacingXs }}>
			{label && <Typography variant='labelSm'>{label}</Typography>}
			<Dropdown
				values={options}
				value={
					props.selectedValue ?
						{
							id: props.selectedValue,
							name: getDeviceStateLabel(props.selectedValue, t),
						}
					:	undefined
				}
				placeholder={t('device.labels.deviceState', { ns: 'entities' })}
				sx={sx}
				canClear
				onValueChanged={(newValue) => {
					props.onValueChanged(newValue?.id as DeviceStateEnum);
				}}
			/>
		</Stack>
	);
};

export default DeviceStateDropdown;
